<template>
  <div class="my-red-route">
    <div class="top-img">
      <img src="../../assets/images/title_wdhslx.png" />
    </div>
    <div class="center-route">
      <CenterRoute noBottom hasPadding :class="[lineList.length&&lineList.length<=3&&'route-box-height']">
        <div class="all-box">
          <div :class="['line-box',lineList.length<=3&&'line-box-3']">
            <div
              v-for="(item, index) in lineList"
              :key="item.id"
              @click="handleJumpRedRoute(item.id)"
              :class="['line-item', listLengthClass]"
            >
              <img :src="require(`../../assets/images/img_road_${getImgNumber}.png`)" />
              <div class="tag">路线{{ index + 1 }}</div>
            </div>
            <div class="nodata" v-if="!isLoading && !lineList.length">
              <img src="../../assets/images/location_icon.png" />
              <div class="nodata-text">你还没有创建红色路线</div>
              <div @click="handleGoIndex" class="create-btn">去创建</div>
            </div>
          </div>
        </div>
      <img v-if="lineList.length>=6" src="../../assets/images/shadow.png" class="shadow-img">
      </CenterRoute>
    </div>
    <div class="bottom-btn">
      <div class="left-btn" @click="handleBack">返回</div>
    </div>
  </div>
</template>

<script>
import { myRedRoutes } from '@/server/interfaces'
import CenterRoute from '../myRedRoute/components/CenterRoute'
import { mapGetters } from 'vuex'
export default {
  name: 'LineRouteItem',
  components: { CenterRoute },
  data() {
    return {
      lineList: [],
      isLoading: true,
    }
  },
  async mounted() {
    if (!this.userInfo.userUuid) {
      await this.$store.dispatch('userInfo/getUserInfo')
    }
    if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
      console.log(this.userInfo)
      await this.$store.dispatch('userInfo/getNfplusUserByLogin')
    }
    this.getRedRouteData()
  },
  computed: {
    ...mapGetters({
      activityId: 'activityInfo/activityId',
      systemInfo: 'systemInfo',
      userInfo: 'userInfo/userInfo',
    }),
    listLengthClass() {
      const length = this.lineList.length
      switch (length) {
        case 2:
          return 'line-2'
        default:
          return ''
      }
    },
    getImgNumber() {
      return this.lineList.length == 2 ? 2 : 1
    },
  },
  methods: {
    async getRedRouteData() {
      this.isLoading = true
      const params = {
        activityId: this.activityId,
      }
      const result = await myRedRoutes({ params })
      this.lineList = result
      this.isLoading = false
    },
    handleJumpRedRoute(id) {
      if (!id) return
      this.$router.push({ path: '/myRedRoute', query: { routeId: id, id: this.activityId } })
    },
    handleGoIndex() {
      this.$router.push({
        path: '/',
        query: { id: this.activityId },
      })
    },
    /**返回上一页 */
    handleBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
.my-red-route {
  width: 100%;
  height: 100vh;
  background: url('../../assets/images/bg_entry.png') no-repeat center center;
  background-size: cover;
  position: relative;
  .top-img {
    height: 1.3rem;
    background-size: cover;
    & > img {
      height: 100%;
      width: 7.5rem;
    }
  }
  .center-route {
    margin-bottom: 0.3rem;
    overflow: hidden;
    position: relative;
    .route-box-height{
      height: 5.9rem;
    }
    .all-box {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 7.46rem;
      padding: 0 0.2rem;
      overflow-y: scroll;
    }
    .nodata {
      width: 100%;
      height: 7.46rem;
      padding-top: 1.4rem;
      box-sizing: border-box;
      background-image: url('../../assets/images/bg_map_route2.png');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      & > img {
        display: block;
        margin: 0 auto;
        width: 0.63rem;
        height: 0.7rem;
      }
      .nodata-text {
        text-align: center;
        font-size: 0.28rem;
        color: #b23f00;
        font-weight: 400;
        margin: 0.3rem 0 0.4rem;
      }
      .create-btn {
        width: 3.2rem;
        text-align: center;
        height: 0.76rem;
        line-height: 0.76rem;
        margin: 0 auto;
        background-image: linear-gradient(180deg, #ff601a 0%, #dc0808 100%);
        border-radius: 0.38rem;
        font-size: 0.3rem;
        color: #fff;
        font-weight: 400;
      }
    }
    .line-box {
      max-height: 100%;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      padding-top: 0.2rem;
      .line-item {
        position: relative;
        width: calc(33.33% - 0.4rem / 3);
        height: 2rem;
        margin-bottom: 0.2rem;
        & > img {
          width: 100%;
          height: 2rem;
        }
        .tag {
          position: absolute;
          width: 1.16rem;
          height: 0.48rem;
          text-align: center;
          line-height: 0.48rem;
          right: 0;
          bottom: 0;
          background-image: linear-gradient(-16deg, #b60000 0%, #e1170b 100%);
          border-radius: 0.3rem 0px 0.2rem;
          font-size: 0.26rem;
          color: #fff;
          font-weight: 600;
        }
      }
      .line-item:last-of-type {
        margin-right: 0 !important;
      }
      .line-item.line-2 {
        width: calc(50% - 0.1rem) !important;
      }
    }
    .line-box-3{
      position: absolute;
      top: 50%;
      transform: translate(0,-50%);
      width: calc(100% - 0.4rem);
      left: 0.2rem;
    }
    .line-box::after {
      content: '';
      width: calc(33.33% - 0.4rem / 3);
    }
    .padding .line-box{
      padding-top: 0 !important;
    }
    .shadow-img{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      border-radius: 0 0 0.2rem 0.2rem;
    }
  }
  .bottom-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.35rem;
    font-size: 0.3rem;
    color: #fff;
    font-weight: 400;
    .left-btn {
      width: 1.63rem;
      height: 0.75rem;
      text-align: center;
      line-height: 0.75rem;
      background: rgba(0, 0, 0, 0.49);
      border-radius: 0.38rem;
      color: #fff;
    }
  }
}
</style>